'use client';

import type { TabName } from './types';
import { TabNavigation } from '@/components/tab-navigation';
import { useParams } from 'next/navigation';
import { useBatch } from '../providers/batch-provider';
interface CourseNavigationProps {
  activeTab: TabName;
}
export function BatchNavigation({
  activeTab
}: CourseNavigationProps) {
  const params = useParams();
  const {
    batch
  } = useBatch();
  const slug = params.slug as string;
  const tabs = [{
    name: 'Batch',
    path: `/batchfinder/${encodeURIComponent(slug)}/batch`
  }, {
    name: 'Join now',
    path: `/batchfinder/${encodeURIComponent(slug)}/join-now`
  }];
  if (batch?.results && (batch.results.photos || batch.results.videos)) {
    tabs.push({
      name: 'Our results',
      path: `/batchfinder/${encodeURIComponent(slug)}/our-results`
    });
  }
  return <TabNavigation tabs={tabs} activeTab={activeTab} className="!items-start !justify-start text-start" data-sentry-element="TabNavigation" data-sentry-component="BatchNavigation" data-sentry-source-file="batch-navigation.tsx" />;
}